import router from '../router'
// import {signInfo,dosign} from '@/api/sign'
// import {
// 	getUser
// } from '../utils/auth';
import utils from '../utils/common';
import baseRequest from './request/baseRequest';
// import { getCode,getWX } from '@/api/user'
// import { getShare } from '@/api/public'
// let _this = this
// 每次跳转页面时候触发
router.beforeEach((to, from, next) => {
	// var str= "http://weike.qdunzi.cn/h5/?from=singlemessage&isappinstalled=0#/"
	// // var str = "aaabbbcccdddeeefff";
	// str = str.match(/(\S*)\?from/)[1]+"#/";
	// console.log(str,23);//结果bbbcccdddeee
	
	//判断二次分享
	let url = window.location.href
	if(url.indexOf("from") != -1){
		window.location.href = url.match(/(\S*)\?from/)[1]+"#"+to.fullPath;
	}
	// 获取推广UID
	if(utils.getUrlKey("tg_uid")){
		sessionStorage.setItem('tg_uid', utils.getUrlKey("tg_uid"));
	}
	//获取get的code
	var token = utils.getUrlKey("token")
	var localToken = localStorage.getItem('user')
	// console.log(token,2222)
	// let token = localStorage.getItem('token');
	
	// console.log('登陆', code,545);
	const promise = new Promise((resolve, reject) => {
		// console.log(token,3)
		if (token&&!localToken) {//console.log(4)
			localStorage.setItem('user',token);
			resolve(localStorage.getItem('urlPath')); 
		}
		else {//console.log(5)
			reject(0);
		}
		
		
	})
	promise.then(function (value) {//console.log(2,value)
		// window.location = value
		let newPath = value
		// console.log(newPath,21234)
		next(newPath)
	}, function (error) {
		// console.log(to,22222)
		console.log("错误",error)
		let url = to.fullPath
		//获取微信跳转链接地址
		// console.log(process.env.VUE_APP_ISWECHAT,1243)
		// if(baseRequest.VUE_APP_ISWECHAT=='test'){
		// 	if (!localToken) {//console.log(1)
		// 		localStorage.setItem('urlPath',url);
		// 		window.location = '/auth'
		// 		// next()
		// 	}
		// 	else {//console.log(2)
		// 	// window.location = localStorage.getItem('urlPath')
		// 		next()
		// 	}
		// }else{//console.log(3)
		// 	next()
		// }
		if (!localToken) {//console.log(1)
			localStorage.setItem('urlPath',url);
			window.location = '/auth'
			// next()
		}
		else if(to.path == "/callback"){//console.log(2)
		// window.location = localStorage.getItem('urlPath')
		// console.log(to,11111)
		// 解决callback不跳首页bug
		window.location.href = "/h5";
			next()
		} else {
			next()
		}
		// next()
	});
	// console.log('路由获取token');
    // next()
})

router.afterEach(() => {
  //console.log(1)
})



